import {createFileRoute} from '@tanstack/react-router'
import React from "react";
import Content from "../../../components/Content.tsx";
import Header from "../../../Header.tsx";
import TournamentsRankingTablesEdit from "../../../tournaments/RankingTables/Edit.tsx";

export const Route = createFileRoute('/_app/tournaments-ranking-tables/$ranking_group_uid')({
    component: RouteComponent,
})

function RouteComponent() {
    return <>
        <Header backUrl={'/tournaments/'} />
        <Content>
            <TournamentsRankingTablesEdit />
        </Content>
    </>
}
